import { useState } from 'react';
import MainCard from 'ui-component/cards/MainCard';
import { Law } from './pages/Law';
import { Box, Button, Grid, LinearProgress } from '@mui/material';
import { PictureAsPdf } from '@mui/icons-material';
import { useTheme } from '@mui/system';
import FirebaseStorageService from 'firebaseService/firebaseStorage';

export const GeneralLaw = () => {
  const [isLoading, setLoading] = useState(false);
  const theme = useTheme();

  const downloadURL = async () => {
    const path = 'formatos/Ley General para la Modernización Digital del Estado - AL 2023.pdf';
    try {
      setLoading(true);
      const url = await FirebaseStorageService.downloadFile(path);
      window.open(url, '_blank');
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <MainCard style={{ marginTop: '20px', paddingBottom: '10px' }} className="animate__animated animate__fadeIn">
        <Law />

        {isLoading && <LinearProgress />}
        <Grid container justifyContent={'center'}>
          <Box>
            <Button variant="outlined" onClick={downloadURL} endIcon={<PictureAsPdf color={theme.palette.grey[500]} />}>
              Descargar documento.
            </Button>
          </Box>
        </Grid>
      </MainCard>
    </>
  );
};
